/* NailHandy — dòng dự báo ngày giao trên trang sản phẩm.
   "Order today – estimated delivery Sep 24–Oct 2", tự tính theo ngày khách đang xem.

   Quy tắc do chủ cửa hàng chốt 11/09/2026:
   - Xử lý 2 ngày làm việc, giao 8–14 ngày làm việc (số nằm ở data-* của snippet).
   - Ngày làm việc = Thứ Hai → Thứ Sáu. Chưa trừ ngày lễ.
   - HÔM NAY là ngày xử lý thứ nhất nếu hôm nay là ngày làm việc; đặt vào Thứ Bảy/Chủ Nhật
     thì ngày xử lý thứ nhất là Thứ Hai kế tiếp. Không có giờ chốt đơn.
   - Chỉ khách ở Mỹ thấy ngày; khách nơi khác thấy một dòng ngắn mời liên hệ.

   Vì sao phải hỏi quốc gia bằng JS: store này KHÔNG tách khách theo Markets — đo 11/09 từ IP
   Việt Nam, trang vẫn báo Shopify.country = "US". Liquid (localization.country) vì thế coi
   mọi người là khách Mỹ. /browsing_context_suggestions.json là định vị theo IP của chính
   Shopify, trả đúng "VN" cho cùng request đó. */
(function () {
  'use strict';

  var el = document.querySelector('[data-nh-eta]');
  if (!el) return;

  var PROC = parseInt(el.dataset.proc, 10) || 2;
  var MIN = parseInt(el.dataset.min, 10) || 8;
  var MAX = parseInt(el.dataset.max, 10) || 14;
  var KEY = 'nh_geo_country';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var textEl = el.querySelector('[data-nh-eta-text]');

  function isBusinessDay(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6;
  }

  // Cộng n ngày làm việc, không tính chính ngày xuất phát.
  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }

  function shipDate(today) {
    // Hôm nay là ngày làm việc => hôm nay đã là ngày xử lý thứ nhất, chỉ còn PROC-1 ngày nữa.
    return isBusinessDay(today) ? addBusinessDays(today, PROC - 1) : addBusinessDays(today, PROC);
  }

  function formatRange(a, b) {
    if (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()) {
      return MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate();
    }
    return MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + MONTHS[b.getMonth()] + ' ' + b.getDate();
  }

  function showEstimate() {
    var ship = shipDate(new Date());
    var range = formatRange(addBusinessDays(ship, MIN), addBusinessDays(ship, MAX));
    textEl.textContent = 'Order today – estimated delivery ';
    var strong = document.createElement('strong');
    strong.textContent = range;
    textEl.appendChild(strong);
    el.dataset.state = 'us';
  }

  function showContact() {
    textEl.textContent = 'Outside the US? ';
    var a = document.createElement('a');
    a.href = el.dataset.contactUrl || '/pages/contact';
    a.textContent = 'Contact us';
    textEl.appendChild(a);
    textEl.appendChild(document.createTextNode(' for delivery times.'));
    el.dataset.state = 'intl';
  }

  function render(country) {
    // Không biết được quốc gia (mạng lỗi) thì theo đúng mặc định của store: coi là khách Mỹ.
    if (country && country !== 'US') showContact();
    else showEstimate();
  }

  /* Xem trước theo quốc gia: ?eta=us (hoặc mã 2 chữ bất kỳ, vd ?eta=vn), ?eta=auto để bỏ.
     Lý do: chủ cửa hàng và nhóm làm việc ở Việt Nam nên luôn bị nhận là khách ngoài Mỹ —
     không có cách nào tự xem bản khách Mỹ thấy. Nhớ theo tab (sessionStorage), mở tab mới là
     về định vị thật. Chỉ đổi phần hiển thị, không ảnh hưởng giá hay giỏ hàng. */
  try {
    var ep = (new URLSearchParams(location.search).get('eta') || '').toUpperCase();
    if (ep === 'AUTO') sessionStorage.removeItem(KEY);
    else if (/^[A-Z]{2}$/.test(ep)) sessionStorage.setItem(KEY, ep);
  } catch (e) {
    /* trình duyệt cũ / chặn lưu trữ — bỏ qua xem trước */
  }

  var cached = '';
  try {
    cached = sessionStorage.getItem(KEY) || '';
  } catch (e) {
    /* trình duyệt chặn lưu trữ — vẫn hỏi mạng như thường */
  }
  if (cached) {
    render(cached);
    return;
  }

  var done = false;
  // Mạng chậm quá thì không bắt khách chờ: sau 2,5 giây hiện theo mặc định.
  var fallback = setTimeout(function () {
    if (done) return;
    done = true;
    render('');
  }, 2500);

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
    credentials: 'same-origin',
    headers: { accept: 'application/json' },
  })
    .then(function (r) {
      return r.ok ? r.json() : null;
    })
    .then(function (j) {
      var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
      if (c) {
        try {
          sessionStorage.setItem(KEY, c);
        } catch (e) {
          /* bỏ qua */
        }
      }
      if (done) return;
      done = true;
      clearTimeout(fallback);
      render(c);
    })
    .catch(function () {
      if (done) return;
      done = true;
      clearTimeout(fallback);
      render('');
    });
})();
